<template>
  <b-overlay
    :show="__isOnLoad"
    variant="white"
    rounded
    opacity="0.70"
    spinner-variant="primary"
    spinner-small
    style="float: left; width: 100%"
  >

  <div class="row pageHeader">
  <div class="row subMenu">
    <b-button
      size="sm"
      variant="danger"
      style="float: right; margin: 5px"
      :class="{ activeFilterButton: showFilter }"
      @click.stop="toggleFilterPanel()"
    >Filtrer</b-button>
    <b-button size="sm" variant="primary" style="float: right; margin: 5px"  @click="dispatchAdd()">+ Compte</b-button>
    </div>

    <transition name="filterOverlayFade">
      <div
        v-if="__editMode === false && showFilter"
        class="filterOverlay"
        @click="closeFilterPanel"
      ></div>
    </transition>

    <transition name="filterDrawer">
      <div
        class="filterDrawerPanel"
        v-if="__editMode === false && showFilter"
        @click.stop
      >
        <div class="filterDrawerHeader">
          <div>
            <div class="filterTitle">Filtres comptes</div>
            <div class="filterMeta">{{filtredListitems.length }} ligne(s) trouvées</div>
          </div>
          <b-button size="sm" variant="outline-secondary" @click="closeFilterPanel">
            Fermer
          </b-button>
        </div>

        <div class="filterDrawerBody">
          <div class="filterSorts">
            <div class="sortTitle">Tri rapide</div>
            <div class="sortGrid">
              <div class="sortItem">
                <b-icon :class="getIsActifSort(sortFiltre.isClient.state)" icon="check-square-fill" @click="sortFiltre.isClient.state = !sortFiltre.isClient.state"></b-icon>
                <span>Client ?</span>
                <b-icon class="redColor" v-if="sortFiltre.isClient.state" icon="recycle" @click="sortFiltre.isClient.isUp = !sortFiltre.isClient.isUp"></b-icon>
              </div>
              <div class="sortItem">
                <b-icon :class="getIsActifSort(sortFiltre.isName.state)" icon="check-square-fill" @click="sortFiltre.isName.state = !sortFiltre.isName.state"></b-icon>
                <span>Nom</span>
                <b-icon class="redColor" v-if="sortFiltre.isName.state" icon="recycle" @click="sortFiltre.isName.isUp = !sortFiltre.isName.isUp"></b-icon>
              </div>
              <div class="sortItem">
                <b-icon :class="getIsActifSort(sortFiltre.isActivated.state)" icon="check-square-fill" @click="sortFiltre.isActivated.state = !sortFiltre.isActivated.state"></b-icon>
                <span>Etat</span>
                <b-icon class="redColor" v-if="sortFiltre.isActivated.state" icon="recycle" @click="sortFiltre.isActivated.isUp = !sortFiltre.isActivated.isUp"></b-icon>
              </div>
            </div>
          </div>

          <div class="filterField">
            <label>Recherche</label>
            <base-input
              placeholder="Nom / tel / cnss / email"
              v-model="filterContainer.keySearchSte"
              type="string"
            >
            </base-input>
          </div>

          <div class="filterField">
            <label>Type utilisateur</label>
            <selector
              v-if="toEditOption !== '676c8c74590157a748c9c8ba'"
              _id="676c8c74590157a748c9c8ba"
              :_editable="true"
              :_asFilter="true"
              :_initFn="setTypeData"
              :_parentItem="filterContainer"
              :_showTitle="false"
              _warpper="filter_type"
            ></selector>
          </div>
        </div>
      </div>
    </transition>
  </div>

    <div :class="getMainPanel">
      <div
        :class="styleSublisteMode + isCurrent(index === showList)"
        v-for="(item, index) in filtredListitems"
        :key="index"
        :style=""
        v-if="__idxOnEdition === -1 || __idxOnEdition === index"
      >
        <div class="directoryCard">
          <div class="directoryCard-head">
            <div class="directoryCard-media">
              <div class="pic"><img :src="getTof(item.pic)" style="width: 56px; height: 56px" /></div>
              <span class="directoryCard-badge" :class="getIsActif(item.isActive === true || item.isActive===1)">
                {{ item.type || 'UTILISATEUR' }}
              </span>
            </div>

            <div class="directoryCard-main">
              <div class="directoryCard-titleRow">
                <b class="directoryCard-title">{{ item.name }}</b>
              </div>
              <em class="directoryCard-subtitle">{{ item.post || 'Compte utilisateur' }}</em>
            </div>

            <div class="directoryCard-menu">
              <div class="menu" v-if="__idxOnEdition !== index && showMenu == index">
                <ico-btn
                  size="p"
                  type="simple"
                  icone="gear-fill"
                  title="Editer"
                  :cb="
                    () => {
                      dispatchEdit(item._id);
                    }
                  "
                ></ico-btn>
                <ico-btn
                  size="p"
                  type="warning"
                  icone="trash"
                  title="Supprimer"
                  :cb="
                    () => {
                      dispatchDelete(item._id);
                    }
                  "
                ></ico-btn>
                <ico-btn size="p" type="toggleOn" custom="orange" icone="eye-slash-fill" v-if=" item.isActive == true" title="Désactiver" :cb="()=>{dispatchDesactive(item._id)}"></ico-btn>
                <ico-btn size="p" type="toggleOff" icone="eye-fill" v-if=" item.isActive == false" title="Activer" :cb="()=>{dispatchActive(item._id)}"></ico-btn>
                <ico-btn
                  size="p"
                  type="toggleOn"
                  icone="reply-fill"
                  title="Fermer le menu"
                  :cb="
                    () => {
                      toggleMenu(index);
                    }
                  "
                ></ico-btn>
              </div>
              <div v-if="__idxOnEdition !== index && showMenu != index">
                <b-icon
                  alt="Menu"
                  class="inlineOptionTrigger"
                  :class="getIsActif(item.isActive === true || item.isActive===1)"
                  icon="gear-fill"
                  title="Gérer"
                  @click="toggleMenu(index)"
                ></b-icon>
              </div>
            </div>
          </div>

          <div class="directoryCard-body">
            <div class="directoryInfoBlock">
              <span class="directoryInfoLabel">CNSS</span>
              <span class="directoryInfoValue">{{ item.cnss || 'Non renseigné' }}</span>
            </div>
            <div class="directoryInfoBlock">
              <span class="directoryInfoLabel">Téléphone</span>
              <span class="directoryInfoValue">{{ item.tel || 'Non renseigné' }}</span>
            </div>
            <div class="directoryInfoBlock">
              <span class="directoryInfoLabel">Email</span>
              <span class="directoryInfoValue directoryInfoValue-break">{{ item.email || 'Non renseigné' }}</span>
            </div>
          </div>
        </div>
       


        


        


      </div>
    </div>
  </b-overlay>
</template>
<script>
import Opts from '@/pages/opts/index';
import user from '@/pages/utilisateurs/index';
export default {
  components: {
    Opts,user
  },
  props: {
    __idxOnEdition: {
      type: Number,
      default: () => {
        return -1;
      },
    },
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    __editMode: {
      type: Boolean,
      default: () => {
        return false;
      },
    },

    
    __onSelect: {
        type: Function,
        default: () => {()=>{}},
      },
  },

  data() {
    return {
      filterContainer: { keySearchSte: "", filter_type : "" },
      structure: { vType: [] },
      showPopup:null,
      showMenu: -1,
      showList: -1,
      showFilter: false,
      toEditOption: '',
      filtredListitems: [],
      selectionMode: false,
      sortFiltre: {
        isClient: {state: false, isUp: true },
        isName:  {state: false, isUp: true },
        isActivated:  {state: false, isUp: true },
      }
    };
  },
  methods: {
    filtredList() {
      var ret = Array.isArray(this.__list) ? [...this.__list] : [];

      if (this.filterContainer.keySearchSte)
        ret = ret.filter((e) =>
        e.name && e.name.includes(this.filterContainer.keySearchSte) ||
        e.tel && e.tel.includes(this.filterContainer.keySearchSte) ||
        e.email && e.email.includes(this.filterContainer.keySearchSte)
        );


      if (this.filterContainer.filter_type)
        ret = ret.filter((e) => e.type === this.filterContainer.filter_type);

        if(this.sortFiltre.isActivated.state === true) {
        if(this.sortFiltre.isActivated.isUp)
          ret = ret.filter((a) => a.isActive === 1 || a.isActive === true);
        else
          ret = ret.filter((b) => b.isActive === 0 || b.isActive === false);
      }

      if(this.sortFiltre.isClient.state === true) {
        if(this.sortFiltre.isClient.isUp)
          ret = ret.filter((a) => a.type !== 'CLIENT');
        else
          ret = ret.filter((a) => a.type === 'CLIENT');
      }

      if(this.sortFiltre.isName.state === true) {
        if(this.sortFiltre.isName.isUp)
          ret = ret.sort((a, b) => String(a.name).localeCompare(String(b.name)));
        else
          ret = ret.sort((a, b) => String(b.name).localeCompare(String(a.name)));
      }

      this.filtredListitems = ret;
      //return ret;
    },

    setTypeData(list) {
      this.structure.vType = list;
    },

    isCurrent(current) {
      if (this.showList !== -1) return current ? "  actif" : " flowted";
      return "";
    },

    toggleMenu(index) {
      if (this.showMenu != index) {
        this.showMenu = index;
      } else {
        this.showMenu = -1;
      }
    },

    toggleList(index) {
      if (this.showList != index) {
        this.showList = index;
      } else {
        this.showList = -1;
      }
    },

    dispatchEdit(idx) {
      this.$parent.editAction(idx);
    },

    dispatchDelete(idx) {
      this.$bvModal
        .msgBoxConfirm("Veuillez confirmer la suppression.", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Confirmer",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: false,
        })
        .then((value) => {
          if (value) {
            this.$parent.deleteAction(idx);
          }
        });
    },

    dispatchActive(idx) {
      this.$parent.toggleActivateAction(idx,1);
    },

    dispatchDesactive(idx) {
      this.$parent.toggleActivateAction(idx,0);
    },

    dispatchAdd() {
      this.$parent.addAction();
    },

    toggleFilterPanel() {
      this.showFilter = !this.showFilter;
    },

    closeFilterPanel() {
      this.showFilter = false;
    },

    getIsActif(isActif) {
      return isActif === true
        ? ""
        : "redColor";
    },

    getTof(c) {
      return this.__.resolveMediaPath(c, 'uploads/users/No-Image.jpg');
      // return "http://localhost:5000/uploads/" + c.split("/uploads/")[1];
      // return "./uploads/" + c.split("/uploads/")[1];
    },

    getIsActifSort(isActif) {
      return isActif === false
        ? "grayColor"
        : "greenColor";
    },
  },
  watch: {
    __isOnLoad: function () {},
  },
  computed: {
    styleSublisteMode() {
      return this.__editMode !== true
        ? "listeMode directoryGridCard col-xl-3 col-lg-4 col-md-6 col-sm-12"
        : "editMode col-md-12";
    },

    

    getMainPanel() {
      if(this.showPopup === false) {
        this.toEditOption = '';
      }
      return "row mainPanelWithoutFilter";
    },
  },
  mounted() {
    setTimeout(()=>this.filtredList(),400)
  },

  watch: {
    __isOnLoad: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValueList")
        this.filtredList()
      },
    },
    __list: {
      deep: true,
      handler() {
        this.filtredList()
      },
    },
    __idxOnEdition: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValueList")
        this.filtredList()
      },
    },
    filterContainer: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValue")
        this.filtredList()
      },
    },
    sortFiltre: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValue")
        this.filtredList()
      },
    },
  },
};
</script>
<style scoped>
.redColor {
  color: red
}
.greenColor {
  color: green;
}
.grayColor {
  color: #CCC;
}
.directoryGridCard {
  margin-bottom: 18px;
}
.editMode {
  float: left;
  padding: 1%;
  margin-bottom: 10px;
  border-radius: 10px;
  min-height: 40px;
  background-color: #fff;
}
.editMode .menu {
  float: right;
  border-radius: 10px;
  background-color: #fff;
}
.listeMode {
  padding: 1%;
  margin-bottom: 10px;
  border-radius: 10px;
  min-height: 40px;
  background-color: #fff;
}

.directoryCard {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 100%;
}

.directoryCard-head {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.directoryCard-media {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
}

.directoryCard-media .pic {
  width: auto;
  margin: 0;
  float: none;
}

.directoryCard-media .pic img {
  display: block;
  object-fit: cover;
}

.directoryCard-main {
  flex: 1 1 auto;
  min-width: 0;
}

.directoryCard-titleRow {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 4px;
}

.directoryCard-title {
  display: block;
  font-size: 18px;
  line-height: 1.25;
}

.directoryCard-subtitle {
  display: block;
  color: #64748b;
  font-size: 13px;
  line-height: 1.45;
}

.directoryCard-badge {
  max-width: 88px;
  padding: 4px 7px;
  border-radius: 999px;
  background: #eef4fb;
  color: #1e2a44;
  font-size: 10px;
  line-height: 1.1;
  text-align: center;
  font-weight: 700;
  white-space: nowrap;
}

.directoryCard-menu {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
}

.directoryCard-body {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 10px;
}

.directoryInfoBlock {
  padding: 12px 14px;
  border-radius: 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.directoryInfoLabel {
  display: block;
  margin-bottom: 4px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.directoryInfoValue {
  display: block;
  color: #1e2a44;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.45;
}

.directoryInfoValue-break {
  word-break: break-word;
}

.listeMode .menu {
  float: right;
  border-radius: 10px;
  background-color: #fff;
}
.pic {
  width: 17%;
  margin-right: 3%;
  float: left;
}
.pic img {
  border-radius: 50%;
}
.preview {
  float: left;
  font-weight: bolder;
}

.preview em {
  font-weight: lighter;
  font-size: 12px;
}

.flowted {
  filter: blur(3.5px);
}

.actif {
  filter: none;
  background-color: #131016;
}

.shop {
  margin-right: 5px;
  color: #2bffc6;
}
.service {
  margin-right: 5px;
  color: #ff8d72;
}
.lubrifiant {
  margin-right: 5px;
  color: #ffd600;
}

.carburant {
  margin-right: 5px;
  color: #b1cf0c;
}

.mainPanelWithoutFilter {
  margin-top: 100px;
  row-gap: 4px;
}

.activeFilterButton {
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.25);
}

.filterOverlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.16);
  z-index: 334;
}

.filterDrawerPanel {
  position: fixed;
  top: 119px;
  right: 0;
  width: min(410px, calc(100vw - 36px));
  height: calc(100vh - 148px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 20px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 0;
  box-shadow: 0 22px 55px rgba(15, 23, 42, 0.2);
  border: 1px solid #dbe4f0;
  z-index: 335;
  display: flex;
  flex-direction: column;
}

.filterDrawerHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e2e8f0;
}

.filterTitle {
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
}

.filterMeta {
  font-size: 14px;
  color: #64748b;
  margin-top: 5px;
}

.filterDrawerBody {
  display: flex;
  flex-direction: column;
  gap: 18px;
  flex: 1 1 auto;
}

.filterSorts {
  padding: 16px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
}

.sortTitle {
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  color: #475569;
  margin-bottom: 12px;
  letter-spacing: 0.04em;
}

.sortGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.sortItem {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #e2e8f0;
  font-size: 15px;
  color: #334155;
}

.sortItem span {
  flex: 1 1 auto;
}

.filterField label {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #475569;
  margin-bottom: 8px;
}

.filterField .form-control,
.filterField .custom-select {
  min-height: 48px;
  font-size: 15px !important;
  border-radius: 12px;
}

.filterDrawer-enter-active,
.filterDrawer-leave-active {
  transition: transform 0.28s ease, opacity 0.28s ease;
}

.filterDrawer-enter,
.filterDrawer-leave-to {
  transform: translateX(28px);
  opacity: 0;
}

.filterOverlayFade-enter-active,
.filterOverlayFade-leave-active {
  transition: opacity 0.22s ease;
}

.filterOverlayFade-enter,
.filterOverlayFade-leave-to {
  opacity: 0;
}

.subMenu {
    width: 100%;
    padding-left: 10%;
    padding-right: 10%;
    background-color: black;
    display: flex !important;
    flex-wrap: wrap !important;
    align-items: center;
    gap: 4px;
    min-height: 40px;
    padding-top: 5px;
    padding-bottom: 5px;
    overflow: visible;
    margin: 0 !important;
  }
  .pageHeader {
    position: fixed;
    top: 120px;
    left: 0;
    width: 100%;
    z-index:333;
    background: #f2f2f2;
    overflow: visible;
  }
  .pageHeader.row,
  .subMenu.row {
    margin-left: 0;
    margin-right: 0;
  }

  .serachPanel {
    position: fixed;
  top: 119px;
    right: 0;
    width: min(420px, calc(100vw - 36px));
    height: calc(100vh - 148px);
    overflow-x: hidden;
    overflow-y: auto;
    padding: 20px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 0;
    box-shadow: 0 22px 55px rgba(15, 23, 42, 0.2);
    border: 1px solid #dbe4f0;
    z-index: 334;
    font-size: 14px;
    animation: filterPanelReveal 0.24s ease;
  }
  .serachPanel.row {
    margin-left: 0;
    margin-right: 0;
  }
  .serachPanel [class*="col-"] {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 0 0 10px;
  }
  .filterPanelHeader {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding-bottom: 14px;
    margin-bottom: 14px;
    border-bottom: 1px solid #e2e8f0;
  }
  .filterPanelTitle {
    font-size: 21px;
    font-weight: 700;
    color: #0f172a;
  }
  .filterPanelCount {
    font-size: 14px;
    color: #64748b;
    margin-top: 4px;
  }
  .filterCloseBtn {
    background: #1f2a44;
    color: #fff;
    border: none;
    border-radius: 10px;
    font-size: 13px;
    padding: 7px 14px;
  }
  .filterQuickTools {
    padding: 14px !important;
    background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
    border: 1px solid #e2e8f0;
  border-radius: 0;
    margin-bottom: 8px;
  }

@media (max-width: 768px) {
  .directoryCard-head {
    flex-wrap: wrap;
  }

  .directoryCard-menu {
    width: 100%;
    justify-content: flex-start;
  }
}
  .filterQuickTitle {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    color: #475569;
    margin-bottom: 10px;
    letter-spacing: 0.04em;
  }
  .serachPanel .form-control,
  .serachPanel .custom-select {
    width: 100%;
    min-height: 46px;
    font-size: 15px !important;
    border-radius: 12px;
  }
  .serachPanel [class*="col-"] {
    font-size: 15px;
  }

@keyframes filterPanelReveal {
  from {
    opacity: 0;
    transform: translateX(24px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 768px) {
  .pageHeader {
    top: 50px;
  }

  .subMenu {
    padding: 6px 10px;
    justify-content: center;
  }

  .filterDrawerPanel {
    top: 119px;
    right: 0;
    width: calc(100vw - 20px);
    height: calc(100vh - 108px);
    padding: 12px;
  }

  .filterDrawerHeader {
    flex-direction: column;
    align-items: stretch;
  }

  .sortGrid {
    grid-template-columns: 1fr;
  }

  .mainPanelWithoutFilter {
    margin-top: 110px;
  }
}
</style>
